// Build out our basic SafeString type
'use strict';

exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/handlebars/dist/cjs/handlebars/safe-string.js
// module id = 36
// module chunks = 0